import React, { useEffect, useState } from 'react'
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar'
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang'
import { useSelectorCustom } from '../../../../components/general/general-component/abstruct-component/useSelectorCustom'
import { DeleteComponent } from '../../../../components/general/general-component/abstruct-component/DeleteComponent'
import Warning from '../../../../components/general/general-component/warning-delete/Warning'
import Table2 from '../../../../components/table/Table2'
import SectionTopOfTable from '../../../../components/general/general-component/section-top-of-table/SectionTopOfTable'
import { ColumnOrders } from '../../../../components/general/general-component/columns-component/ColumnOrders'
import { deleteDelivery, loadDeliveries } from '../../../../store/Actions/ActionDelivery'
import { ColumnDeliveries } from '../../../../components/general/general-component/columns-component/ColumnDeliveries'

const fake = [
    {
        id: 1,
        request_date: "2024-04-15",
        received_by: "John Doe1",
        location: "Warehouse A"
    },
    {
        id: 2,
        request_date: "2024-04-15",
        received_by: "John Doe2",
        location: "Warehouse B"
    },
    {
        id: 3,
        request_date: "2024-04-15",
        received_by: "John Doe3",
        location: "Warehouse C"
    },
]
const Delivery = () => {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang()
    const { deliveries, loadingDeliveries } = useSelectorCustom()
    //const { state, setOpen, handleEdit, setopenEdit, setStateCustom } = VariableRequests()
    const { stateD, warning, setdeletee, setloadDel } = DeleteComponent()
    const [deliveryArr, setDeliveryArr] = useState(fake)
    const [isDeleted, setIsDeleted] = useState('')
    const [idDeleted, setIdDeleted] = useState(null)
    useEffect(() => {
        if (isDeleted && idDeleted) {
            const updatedArr = [...deliveryArr];
            const indexToDelete = updatedArr.findIndex(item => item.id === idDeleted);
            if (indexToDelete !== -1) {
                updatedArr.splice(indexToDelete, 1);
                setDeliveryArr(updatedArr);
            }
        }
    }, [isDeleted, idDeleted, deliveryArr]);
    /*useEffect(() => {
        if (deliveries?.length >= 0) {
            setDeliveryArr(deliveries)
        }
    }, [deliveries]);*/

    /*useEffect(() => {
        dispatch(loadDeliveries())
    }, []);*/
    const handleDelete = (id) => {
        dispatch(deleteDelivery(id, setloadDel, setIsDeleted, setIdDeleted));
    }
    const { columns } = ColumnDeliveries(translate, warning, langLocal)
    return (
        <>
            <main>
                {/*<FilterRequest translate={translate} />*/}
                <div className="div_table" dir={langLocal == "ar" ? "rtl" : "ltr"} >
                    <SectionTopOfTable langLocal={langLocal} title={translate('delivery')}   />
                    {/*
                        loadingWarehouses == false ? (
                            <Table2 col={columns} roo={warehousesArr} />
                        ) : <InnerLoader />
                        */}
                    <Table2 col={columns} roo={deliveryArr} />
                </div>
                {
                    stateD.deletee == true ? (
                        <Warning loadDel={stateD.loadDel} arr={stateD.arrW} open={stateD.deletee} setOpen={setdeletee} handleDelete={handleDelete} />
                    ) : <></>
                }
            </main>
        </>
    )
}

export default Delivery

